class S84ClassToggler {
  constructor() {
    this.naja = null;
  }

  initialize(naja) {
    this.naja = naja
    this.naja.addEventListener('init', () => {
      this.bindElements();
    });
    this.naja.addEventListener('complete', () => {
      this.bindElements();
    });
  }

  bindElements() {
    let elements = document.getElementsByClassName('s84-class-toggle');
    for (let i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].removeEventListener('click', this.clickElement);
        elements[i].addEventListener('click', this.clickElement); //.bind(this)
      }
    }
  }

  clickElement(event) {
    event.preventDefault();
    let search = document.getElementsByClassName(event.target.dataset.s84Target);
    for (let i in search) {
      if (search.hasOwnProperty(i)) {
        let el = search[i];
        // if (el.classList.contains('s84-toggle-show')) {
        //   el.classList.remove('s84-toggle-show');
        // } else {
        //   el.classList.add('s84-toggle-show');
        // }
        if (el.classList.contains('hidden')) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      }
    }
  }
}


export default S84ClassToggler
